// FB 14847
import React, { useCallback, useState, useEffect } from 'react';
import _ from 'lodash';
import {
    Link, InputNumberField, IconButton
} from '@jutro/components';
import { withIntl } from '@jutro/locale';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './RIFormsListComponent.metadata.json5';
import messages from './RIFormsListComponent.messages';
import styles from './RIFormsListComponent.module.scss';

const RIFormsListComponent = (props) => {
    const { formsFullList, selectedItemsBack } = props;

    const clickNext = (selectedItems) => {
        props.capability[0](selectedItems);
    };

	const disableStep = (i) => {
		props.capability[2](i);
	}

    const clearVisitedStep = (i) => {
        props.capability[3](i);
    };

    const [formsList, setFormsList] = useState([]);
    const [formsListSave, setFormsListSave] = useState([]);
    const [categoryValues, setCategoryValues] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [searchKeyword, setSearchKeyword] = useState('');
	const [selectedItems, setSelectedItems] = useState([])
    const [itemSelected, setItemSelected] = useState(false);
    useEffect(() => {
	    const formsList = [...formsFullList]; 
        
        setCategoryValues(getFormCategory(formsList)); 
		fiterFormsList(selectedItemsBack,formsList);
		setFormsList(formsList);
		setFormsListSave(formsList);
    }, [formsFullList]);

    useEffect(() =>{
		// Search the formsListSave, then set the formsList
		filterTableData(formsListSave,searchKeyword);
    }, [searchKeyword]);

	useEffect(() =>{
		// Return from step 2
		if(selectedItemsBack.length > 0){
			setSelectedItems(selectedItemsBack)
		}
    }, [selectedItemsBack]);

    // Biuld the Dropdowns values
    const getFormCategory = (forms) => {
        const categorySelect = [
			{
				code: 'All',
				name: 'All'
			}
		];

        const categoryArray = forms.map(data => data.category);
        
        new Set(categoryArray).forEach(category => {
            categorySelect.push(
				{
					code: category,
					name: category
				}
			);
        });
        
        return categorySelect;
    };    

	// Select item from the formsList
    const writeValue = useCallback(
        (value, path, id) => {
            
            if(_.isNumber(value) && value > 0){
                setItemSelected(true);
            }
            const newformsList = _.clone(formsList);            
            const index = id.fieldUniqueId.split('_')[0];
            _.set(newformsList[index], path, value);		
            
            setFormsList(newformsList);
        },
        [formsList, setFormsList]
    );

	// Change order items quantity for selectedItems
    const writeValue2 = useCallback(
        (value, path, id) => {
            const newformsList = _.clone(selectedItems);
            const index = id.fieldUniqueId.split('_')[0];
            _.set(newformsList[index], path, value);        
			setSelectedItems(newformsList);
			// When changed the quantity in selected item, disable the next step
			// user need to click the Process Order button to the step 2.
			disableStep(1);
            clearVisitedStep(1);
        },
        [selectedItems, setSelectedItems]
    );

    const getQtyInput = (item, index, property) => {
        return (
            <InputNumberField
                id={`${index}`}
                path={`quantity`}
                onValueChange={writeValue}
                value={item[property.id]}   
				className={styles.riQtyInput}         
				minValue={0} 
				maxValue={1000} 
                hideLabel
            />
        );
    };                          
    const getQtyInput2 = (item, index, property) => {
        return (
            <InputNumberField
                id={`${index}`}
                path={`quantity`}
                onValueChange={writeValue2}
                value={item[property.id]}   
				className={styles.riQtyInput}         
				minValue={1} 
				maxValue={1000} 
                hideLabel
            />
        );
    };           
	
    const getDeleteIcon = (item, index, property) => {
		return (
			<IconButton 
				icon='mi-delete'
				onClick={() => deleteDataRow(item,index,property)}
				iconColor={`neutral`}
				tooltip={{
					href: '',
					link: '',
					placement: 'left',
					text: '',
					title: ''
				  }}
			/>
		);
	};

	const addToOrder = useCallback(() => {
        const newSelectedItems = formsList.filter(form => {
			return _.isNumber(form.quantity) && form.quantity != 0;
		})		

		if(newSelectedItems.length === 0){
            setItemSelected(false);
		}else {
            setItemSelected(true);
			// Add the newSelectedItems to the selectedItems
			setSelectedItems([...selectedItems, ...newSelectedItems]);

			// Remove the itmes in newSelectedItems from the formsList.
			// The formsList may be filtered by category or serach keyword.
			// The formsList and the formsListSave may not be same.
			fiterFormsList(newSelectedItems, formsList);						
			setFormsList(formsList);

			if(formsList.length === 0 && searchKeyword !== ''){
				setSearchKeyword('');				
			}

			// Remove the itmes in newSelectedItems from the formsListSave
			fiterFormsList(newSelectedItems, formsListSave);
			setFormsListSave(formsListSave);

			if(formsList.length === 0){
				setFormsList(formsListSave);
				setSelectedCategory('All');
			}
			
			disableStep(1);
            clearVisitedStep(1);
		}

    }, [formsList]);
	
	const fiterFormsList = (newSelectedItems, formsList) =>{
		newSelectedItems.forEach((newOne) => {

			for (let i = formsList.length - 1; i >= 0; i--) {
				if (formsList[i].resourceName === newOne.resourceName && formsList[i].state === newOne.state) {
					formsList.splice(i, 1);
					break;
				}
			}
		});
	}

	const gotoProcessOrder = useCallback(() => {
		let zeroQty = false;
		
		selectedItems.forEach(item => {			
			if(item.quantity < 1 || !_.isNumber(item.quantity)){
				zeroQty = true;
			}
		});

		if(!zeroQty){
			clickNext(selectedItems);
		}
			
    }, [selectedItems]);

	const deleteDataRow = useCallback(		
        (row, index) => {

			let formListTemp = [...formsFullList];
			_.forEach(formListTemp, (item) => {
				if(selectedItems[index].resourceName === item.resourceName && selectedItems[index].state === item.state){
					item.quantity = '';
				}
			})

            const newData = [...selectedItems];
            newData.splice(index, 1);
            setSelectedItems(newData);
			
			// Added the deleted row back to the formList
			if(newData.length > 0){
				fiterFormsList(newData,formListTemp);
			}else{
                setItemSelected(true);
            }

			// If an item is deleted, disable step 2.
			disableStep(1);
			clearVisitedStep(1);
			setFormsList(formListTemp);
			setFormsListSave(formListTemp);
			// setSelectedCategory('All');
        },
        [selectedItems]
    );

    const handleFilterValueChange = (value) => {    
        setSelectedCategory(value);
        let filteredList = formsListSave;

        if (value && value !== 'All') {
            filteredList = _.filter(formsListSave, (form) => {
                return form.category === value;
            });
        }        
        
        setFormsList(filteredList);
    };

    const handleSearchValueChange = useCallback((keyword) => {
        setSearchKeyword(keyword);
		if(!_.isEmpty(keyword)){
			// setSelectedCategory('All');
		}
    }, []);

    const filterTableData = (formsData, keyword) => {
		
        const filterForms = (forms) => {
            
            if (_.isEmpty(keyword)) {
                return forms;
            }

            return _.filter(forms, (form) => {           
                
                const filetedform = ( form.category === selectedCategory || selectedCategory === 'All' ) &&  
									(_.includes(form.category.toLocaleLowerCase(),keyword.toLocaleLowerCase()) ||
                                    _.includes(form.resourceName.toLocaleLowerCase(),keyword.toLocaleLowerCase()) ||
                                    _.includes(form.state.toLocaleLowerCase(),keyword.toLocaleLowerCase()) ||
                                    _.includes(form.resourceDesc.toLocaleLowerCase(),keyword.toLocaleLowerCase()) ||
                                    _.includes(form.language.toLocaleLowerCase(),keyword.toLocaleLowerCase()));                 
                return filetedform;
            });
        };
        
        if (!_.isEmpty(formsData)) {
            const filteredFormList = filterForms(formsData);
			// Set the formList with filtered data
            setFormsList(filteredFormList);
        }
    };	
	const getDownloadLink = () => {
		return (
			<div className={styles.riLinkDetails}>
				{`Republic Indemnity has a variety of claims forms, posters, pamphlets, and supplies that either you can download or we can ship to you.  `}
				<Link href={`https://www.republicindemnity.com/employers/claims/claims-resources`} 					
					target={`_blank`}
				>
					{`Click here to download forms.`}
				</Link>  
				<br></br>
				{` To place an order, enter a quantity in the form below and press the "Add to the Order" button.`}
			</div>
		);
	};            
    const overrideProps = {
        formsListTableGrid: {
            data: formsList
        },
        formCategory: {
            availableValues: categoryValues,
            value: selectedCategory
        },
        searchFilter: {
            value: searchKeyword
        },
		orderContainer: {
			visible: selectedItems.length > 0
		},
		selectedItemsTable: {
			data: selectedItems
		},
        addToOrderButton: {
            disabled: !itemSelected
        },
		downloadlink: {
			content: getDownloadLink()
		}	
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            handleFilterValueChange,
            handleSearchValueChange,
			getQtyInput,
			getQtyInput2,
			addToOrder,
			clickNext,
			gotoProcessOrder,
			deleteDataRow,
			getDeleteIcon
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
};

export default withIntl(withAuthenticationContext(RIFormsListComponent));


